<template>
  <div class="card">
    <div class="card-body">
      <h4>{{ $t('myLogOffer.mnimTklifim') }}</h4>

      <div
        v-for="(p,i) in getPQTPrices()"
        :key="i"
      >
        <!-- ROW 1: MAIN PRODUCT -->
        <div class="row">
          <!-- LEFT: Main Product Detail -->
          <div class="col-6">
            <strong>{{ p.product.name }}</strong><br>
            <span>{{ p.product.count }} {{ p.product.unit }}</span><br>

            <strong>{{ $t("request.xsusiTlblr") }}</strong><br>
            <span
              v-for="(req, index) in p.reqDetail"
              :key="`req-${index}`"
            >
              {{ `${index + 1}. ` }}{{ req.detail }} <br>
            </span>
            <br>

            <!-- Main Product Tech Specs Files -->
            <div
              v-for="(f, ii) in p.techSpecsFiles"
              :key="ii"
              class="col-md-12"
            >
              <a
                v-if="isPhoto(f)"
                target="_blank"
                :href="getPhoto(f, '')"
              >
                <img
                  :src="getPhoto(f, 'medium', '/images/no-image.png')"
                  class="img-thumbnail"
                  style="max-height: 200px;"
                  alt="-"
                >
              </a>
              <a
                v-else
                target="_blank"
                :href="getPhoto(f, '')"
                class="card border border-dark"
                style="height: 100%"
              >
                <div
                  class="card-body d-flex text-dark w-100
                 justify-content-center align-items-center"
                >
                  {{ $t("newAUCRequest.lavFayl") }} <br> *.{{ f.split('.').pop() }}
                </div>
              </a>
            </div>

            <!-- Main Product Technical Specification -->
            <span>
              <strong>{{ $t("myPQTOffer.texnikiSpesifikasiya") }}</strong>:
              {{ p.techSpecification }}
            </span>
          </div>

          <!-- RIGHT: Main Product Pricing -->
          <div
            class="col-6"
            :style="p.isSelected? 'border: 2px solid red;' : ''"
          >
            <div class="d-flex justify-content-end align-items-center">
              <strong>
                {{ p.price }} ₼ x {{ p.product.count }} {{ p.product.unit }}
              </strong>
              <span class="ml-2">
                {{ (p.price * p.product.count).toFixed(2) }} ₼
              </span>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <strong>{{ $t('myPQTOffer.taxId') }}:</strong>
              <span class="ml-2">
                {{
                  p.isVatPayer
                    ? (p.price * p.product.count * 0.18).toFixed(2)
                    : 0
                }} ₼
              </span>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <strong>{{ $t("myPQTOffer.overAllPrice") }}:</strong>
              <span class="ml-2">
                {{
                  p.isVatPayer
                    ? (p.price * p.product.count * 0.18 + p.price * p.product.count).toFixed(2)
                    : (p.price * p.product.count).toFixed(2)
                }} ₼
              </span>
            </div>
            <div
              v-if="p.isSelected"
              class="d-flex justify-content-end align-items-center"
            >
              <strong>{{ $t('myPQTOffer.selectedOffer') }}</strong>
            </div>
          </div>
        </div>

        <!-- ROW 2: ALTERNATIVE PRODUCT (shown only if it exists) -->
        <div
          v-if="p.alternativeOffer"
          class="row"
        >
          <!-- LEFT: Alternative Product Detail -->
          <div
            class="col-6 mt-3"
            :style="p.alternativeOffer.isSelected? 'border: 2px solid red;' : ''"
          >
            <hr>
            <strong class="text-primary">
              {{ $t('request.alternativTklif') }}
            </strong><br>
            <strong class="text-primary">
              {{ p.alternativeOffer.productName }}
            </strong><br>

            <!-- Alternative Product Tech Specs Files -->
            <div
              v-for="(f, ii) in p.techSpecsFilesAlternative"
              :key="ii"
              class="col-md-12"
            >
              <a
                v-if="isPhoto(f)"
                target="_blank"
                :href="getPhoto(f, '')"
              >
                <img
                  :src="getPhoto(f, 'medium', '/images/no-image.png')"
                  class="img-thumbnail"
                  style="max-height: 200px;"
                  alt="-"
                >
              </a>
              <a
                v-else
                target="_blank"
                :href="getPhoto(f, '')"
                class="card border border-dark"
                style="height: 100%"
              >
                <div
                  class="card-body d-flex text-dark w-100
                 justify-content-center align-items-center"
                >
                  {{ $t("newAUCRequest.lavFayl") }} <br> *.{{ f.split('.').pop() }}
                </div>
              </a>
            </div>

            <!-- Alternative Product Technical Specification -->
            <span class="text-primary">
              <strong class="text-primary">
                {{ $t("myPQTOffer.texnikiSpesifikasiya") }}
              </strong>:
              {{ p.alternativeOffer.techSpecs }}
            </span>
          </div>

          <!-- RIGHT: Alternative Product Pricing -->
          <div class="col-6 mt-3 text-primary">
            <hr>
            <div class="d-flex justify-content-end align-items-center">
              <strong>
                {{ p.alternativeOffer.price }} ₼ x {{ p.product.count }} {{ p.product.unit }}
              </strong>
              <span class="ml-2">
                {{ p.alternativeOffer.price * p.product.count }} ₼
              </span>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <strong>ƏDV:</strong>
              <span class="ml-2">
                {{
                  p.alternativeOffer.isVatPayer
                    ? p.alternativeOffer.price * p.product.count * 0.18
                    : 0
                }} ₼
              </span>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <strong>Yekun qiymət:</strong>
              <span class="ml-2">
                {{
                  p.alternativeOffer.isVatPayer
                    ? p.alternativeOffer.price * p.product.count * 0.18
                      + p.alternativeOffer.price * p.product.count
                    : p.alternativeOffer.price * p.product.count
                }} ₼
              </span>
            </div>
            <div
              v-if="p.alternativeOffer.isSelected"
              class="d-flex justify-content-end align-items-center"
            >
              <strong>{{ $t('myPQTOffer.selectedOffer') }}</strong>
            </div>
          </div>
        </div>

        <hr>
      </div>
      <div v-if="myPQTOffer">
        <strong>{{ $t('myPQTOffer.tklifinEtibarllqTarixi') }} </strong>
        {{ myPQTOffer.valid.trim() === '' ? $t('myPQTOffer.noDate') : getMoment(myPQTOffer.valid) }}
        <br>
        <strong>{{ $t('detailedComparisonModal.deliveryOption') }}</strong>
        {{ myPQTOffer.deliveryDays + $t('myPQTOffer.day') + myPQTOffer.incoterms }}
        {{ myPQTOffer.incoterms === 'DDP' ? requestExtras.deliveryAddress : '' }} <br>
        <strong>{{ $t('detailedComparisonModal.manufacturerCountry') }}</strong>
        {{ myPQTOffer.manufacturerCountry }} <br>
        <strong>{{ $t('detailedComparisonModal.paymentOption') }}</strong>
        {{ getPaymentOptionLabel(myPQTOffer.paymentOption) }}
        {{ myPQTOffer.paymentComment !== undefined ? myPQTOffer.paymentComment : '' }} <br>
        <strong>{{ $t('detailedComparisonModal.warrantyPeriod') }}</strong>
        {{
          myPQTOffer.warrantyPeriod + $t('myPQTOffer.month') + myPQTOffer.warrantyComment !== undefined ? myPQTOffer.warrantyComment : ''
        }} <br>
        <div
          v-if="myPQTOffer.files"
          class="mb-2"
        >
          <strong>{{ $t('myPQTOffer.fayllar') }}</strong> <br>
          <div class="row">
            <div
              v-for="(f,i) in myPQTOffer.files.split(',')"
              :key="i"
              class="col-md-3"
            >
              <a
                v-if="isPhoto(f)"
                target="_blank"
                :href="getPhoto(f,'')"
              >
                <img
                  :src="getPhoto(f,'medium','/images/no-image.png')"
                  class="img-thumbnail"
                  style="max-height: 200px;"
                  alt="-"
                >
              </a>
              <a
                v-else
                target="_blank"
                :href="getPhoto(f,'')"
                class="card border border-dark "
                style="height: 100%"
              >
                <div class="card-body d-flex text-dark w-100 justify-content-center align-items-center ">
                  {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <hr>


      <div class="py-2 lead d-flex justify-content-between">
        <span class="badge bg-warning">
          {{ $t('myPQTOffer.toplamTklif') }} {{ $t('myPQTOffer.azn', {totalPrice: mainTotal.toFixed(2)}) }}
        </span>
        <!-- Main total -->

        <span
          v-if="alternativeTotal > 0"
          class="badge bg-success"
        >
          Alternativ Təklif Toplam 
          {{ $t('myPQTOffer.azn', {totalPrice: alternativeTotal.toFixed(2)}) }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import {getPhoto} from "@/repositories/Utils";
import moment from "moment";
import {getPaymentOptionLabel} from "@/repositories/GeneralDataRepository";

export default {
  name: 'MyPQTOffer',
  props: {
    products: {},
    offers: {},
    request: {}
  },

  computed: {
    mainTotal() {
      // Sum of main prices across all items in the first offer
      return this.getPQTPrices().reduce((acc, item) => {
        const base = item.price * item.product.count;
        // If item is VAT payer, multiply by 1.18
        return acc + (item.isVatPayer ? base * 1.18 : base);
      }, 0);
    },
    alternativeTotal() {
      const prices = this.getPQTPrices();
      // Check if any object has an alternativeOffer
      if (!prices.some(item => item.alternativeOffer)) {
        return 0;
      }
      // Sum of alternative prices (if any) across all items
      return this.getPQTPrices().reduce((acc, item) => {
        // Only add if there's an alternativeOffer
        if (item.alternativeOffer) {
          const base = item.alternativeOffer.price * item.product.count;
          return acc + (item.alternativeOffer.isVatPayer ? base * 1.18 : base);
        } else {
          const base = item.price * item.product.count;
          return acc + (item.isVatPayer ? base * 1.18 : base);
        }

      }, 0);
    },
    myPQTOffer() {
      if (this.offers.length > 0) {
        return JSON.parse(this.offers[0].prices)['extras']
      }
      return null;
    },
    requirements() {
      if (this.offers.length > 0) {
        return JSON.parse(this.offers[0].prices)['prices']
      }
      return null;
    },
    requestExtras() {
      return JSON.parse(this.request.extras)
    }
  },


  methods: {
    getPaymentOptionLabel,
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getPQTPrices() {

      let prices = [];

      let json = JSON.parse(this.offers[0].prices);
      if (!json.prices) return [];
      json.prices.forEach((k) => {
        prices.push({
          product: this.getProductById(k.product),
          price: k.price,
          isVatPayer: k.isVatPayer === 'true',
          reqDetail: k.reqDetails,
          techSpecification: k.techSpecification,
          techSpecsFiles: k.techSpecsFiles,
          isSelected: k.isSelected,
          techSpecsFilesAlternative: k.techSpecsFilesAlternative,
          alternativeOffer: k.alternativeOffer
        })
      })
      return prices;

    },

    getProductById(id) {

      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })

      return prod;

    },
  }
}
</script>
